import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, withRouter, useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import cx from "classnames";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { getOrganizationRoute } from "../_pages/org-details.page";
import { TRACK_MANAGEMENT_ROUTE } from "../_pages/track-management.page";
import { SURVEY_ROUTE } from "../_pages/survey.page";
import { MIXPANEL_ROUTE } from "../_pages/mixpanel.page";

function SidebarComponent({ user, orgData }) {
  let history = useHistory();
  return (
    <div
      className={
        cx("Sidebar")
        // {
        //     "open": isSidebarOpen,
        //     "no-switcher": sidebarIgnoresCommunitySwitcher || !user
        // }
      }>
      <div className="sidebar-content bg-white">
        <div className="group-link-holder m-auto" style={{ maxWidth: "102px" }}>
          <div
            className={cx(
              "sidebar-heading-holder  items-center py-3 rounded-md cursor-pointer "
            )}
            onClick={() => history.push("/")}>
            <div>
              <div className="sidebar-heading font-semibold">Overview</div>
            </div>
          </div>
        </div>
        {user.role === "superAdmin" ? (
          <div
            className="group-link-holder m-auto"
            style={{ maxWidth: "102px" }}>
            <div
              className={cx(
                "sidebar-heading-holder items-center py-3 rounded-md cursor-pointer "
              )}
              onClick={() => history.push("/organizations")}>
              <div>
                <div className="sidebar-heading font-semibold">
                  Organizations
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {user.role === "orgAdmin" ? (
          <div
            className="group-link-holder m-auto"
            style={{ maxWidth: "102px" }}>
            <div
              className={cx(
                "sidebar-heading-holder items-center py-3 rounded-md cursor-pointer "
              )}
              onClick={() =>
                history.push({
                  // pathname: getOrganizationRoute(orgData.organization._id)
                  pathname: `/organization`,
                  search: "?orgId=" + orgData.organization._id,
                  state: { openTab: 1 },
                })
              }>
              <div>
                <div className="sidebar-heading font-semibold">
                  Organization
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {user.role === "superAdmin" ? (
          <>
            <div
              className="group-link-holder m-auto"
              style={{ maxWidth: "102px" }}>
              <div
                className={cx(
                  "sidebar-heading-holder  items-center py-3 rounded-md cursor-pointer "
                )}
                onClick={() => {
                  user.role === "orgAdmin"
                    ? history.push({
                        pathname: `/organization`,
                        search: `?orgId=${orgData.organization._id}`,
                        state: { openTab: 2 },
                      })
                    : history.push("/users");
                }}>
                <div>
                  <div className="sidebar-heading font-semibold">User Data</div>
                </div>
              </div>
            </div>
            <div
              className="group-link-holder m-auto"
              style={{ maxWidth: "102px" }}>
              <div
                className={cx(
                  "sidebar-heading-holder items-center py-3 rounded-md cursor-pointer "
                )}
                onClick={() => history.push("/community-management")}>
                <div>
                  <div className="sidebar-heading font-semibold">
                    Community Management
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        {user.role === "superAdmin" ? (
          <div
            className="group-link-holder m-auto"
            style={{ maxWidth: "102px" }}>
            <div
              className={cx(
                "sidebar-heading-holder items-center py-3 rounded-md cursor-pointer "
              )}
              onClick={() => history.push(TRACK_MANAGEMENT_ROUTE)}>
              <div>
                <div className="sidebar-heading font-semibold">
                  Track Management
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {user.role === "orgAdmin" ? (
          <div
            className="group-link-holder m-auto"
            style={{ maxWidth: "102px" }}>
            <div
              className={cx(
                "sidebar-heading-holder items-center py-3 rounded-md cursor-pointer "
              )}
              onClick={() => history.push(SURVEY_ROUTE)}>
              <div>
                <div className="sidebar-heading font-semibold">Surveys</div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {/* {user.role === "orgAdmin" ? (
          <div
            className="group-link-holder m-auto"
            style={{ maxWidth: "102px" }}>
            <div
              className={cx(
                "sidebar-heading-holder items-center py-3 rounded-md cursor-pointer "
              )}
              onClick={() => history.push(MIXPANEL_ROUTE)}>
              <div>
                <div className="sidebar-heading font-semibold">Mix Panel</div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )} */}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
  orgData: state.orgData,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const Sidebar = withToast(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(SidebarComponent))
);

export default Sidebar;
